export { default as RegisterKinder } from './RegisterKinder'
export { default as DirectKinder } from './DirectKinder'
export { default as RequestedIVes } from './RequestedIVes'
export { default as RegisterKinderClasses } from './RegisterKinderClasses'
export { default as UserInfo } from './UserInfo'



// WEBPACK FOOTER //
// ./src/UserAccount/components/index.js